import router from "./router";
import helpers from "./helpers";
export default {
    sendGet: (endpoint, data = {}) => {
        return window.axios.get(endpoint, {
            params: data,
        }).catch((error) => {
            if (error.response.status == 401) {
                if (typeof error.response.data.code != 'undefined' && error.response.data.code == 101) {
                    window.location.href = '/change-password';
                } else router.push({ name: 'login' });
            } else if (error.response.status > 400) {
                helpers.handleGlobalError(error);
            }
            return error;
        });
    },
    sendPost: (endpoint, data = {}) => {
        return window.axios.post(endpoint, data).catch((error) => {
            if (error.response.status == 401) {
                if (typeof error.response.data.code != 'undefined' && error.response.data.code == 101) {
                    window.location.href = '/change-password';
                } else router.push({ name: 'login' });
            } else if (error.response.status > 400) {
                helpers.handleGlobalError(error);
            }
            return error;
        });
    },

    sendDelete: (endpoint, data = {}) => {
        return window.axios.delete(endpoint, {
            params: data,
        }).catch((error) => {
            if (error.response.status == 401) {
                if (typeof error.response.data.code != 'undefined' && error.response.data.code == 101) {
                    window.location.href = '/change-password';
                } else router.push({ name: 'login' });
            } else if (error.response.status > 400) {
                helpers.handleGlobalError(error);
            }
            return error;
        });
    },

    uploadFile: (endpoint, data = {}) => {
        var formData = new FormData();
        for (var key in data) {
            formData.append(key, data[key]);
        }
        return window.axios.post(endpoint, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).catch((error) => {
            if (error.response.status == 401) {
                if (typeof error.response.data.code != 'undefined' && error.response.data.code == 101) {
                    window.location.href = '/change-password';
                } else router.push({ name: 'login' });
            } else if (error.response.status > 400) {
                helpers.handleGlobalError(error);
            }
            return error;
        });
    }
}
